<mat-accordion multi class="expand-collapse-panel">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
    </mat-expansion-panel-header>
    <form autocomplete="off" [formGroup]="form" id="filterCustomerDocument" class="filter-form">
      <div class="filter-field">
        <mat-form-field class="search-input">
          <mat-label>Document Id</mat-label>
          <input placeholder="Document Id"
            matInput
            [matChipInputFor]="chipDocumentId"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="applyFilter($event, 'documentids')">
          </mat-form-field>
          <mat-chip-grid #chipDocumentId>
            @for (item of documentIds; track item) {
              <mat-chip-row
                [removable]="removable" (removed)="remove(item, 'documentids')">
                {{item}}
                @if (removable) {
                  <mat-icon matChipRemove>cancel</mat-icon>
                }
              </mat-chip-row>
            }
          </mat-chip-grid>
        </div>
        <div class="filter-field">
          <mat-form-field class="search-input">
            <mat-label>Customer ID</mat-label>
            <input placeholder="Customer ID"
              matInput
              [matChipInputFor]="chipCustomerId"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="applyFilter($event, 'customerids')">
            </mat-form-field>
            <mat-chip-grid #chipCustomerId>
              @for (item of customerIds; track item) {
                <mat-chip-row
                  [removable]="removable" (removed)="remove(item, 'customerids')">
                  {{item}}
                  @if (removable) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
            </mat-chip-grid>
          </div>
          <div class="filter-field">
            <mat-form-field class="search-input">
              <mat-label>Contract number</mat-label>
              <input placeholder="Contract Number"
                matInput
                [matChipInputFor]="chipContractNumber"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="applyFilter($event, 'contractnumbers')">
              </mat-form-field>
              <mat-chip-grid #chipContractNumber>
                @for (item of contractNumbers; track item) {
                  <mat-chip-row
                    [removable]="removable" (removed)="remove(item, 'contractnumbers')">
                    {{item}}
                    @if (removable) {
                      <mat-icon matChipRemove>cancel</mat-icon>
                    }
                  </mat-chip-row>
                }
              </mat-chip-grid>
            </div>
            <div class="filter-field">
              <mat-form-field class="search-input">
                <mat-label>Unit Id</mat-label>
                <input placeholder="Unit Id"
                  matInput
                  [matChipInputFor]="chipUnitId"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="applyFilter($event, 'unitids')">
                </mat-form-field>
                <mat-chip-grid #chipUnitId>
                  @for (item of unitIds; track item) {
                    <mat-chip-row
                      [removable]="removable" (removed)="remove(item, 'unitids')">
                      {{item}}
                      @if (removable) {
                        <mat-icon matChipRemove>cancel</mat-icon>
                      }
                    </mat-chip-row>
                  }
                </mat-chip-grid>
              </div>
              <div class="filter-field">
                <mat-form-field class="search-input">
                  <mat-label>Document Type</mat-label>
                  <input placeholder="Document Type"
                    matInput
                    [matChipInputFor]="chipDocumentType"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="applyFilter($event, 'documenttypes')">
                  </mat-form-field>
                  <mat-chip-grid #chipDocumentType>
                    @for (item of documentTypes; track item) {
                      <mat-chip-row
                        [removable]="removable" (removed)="remove(item, 'documenttypes')">
                        {{item}}
                        @if (removable) {
                          <mat-icon matChipRemove>cancel</mat-icon>
                        }
                      </mat-chip-row>
                    }
                  </mat-chip-grid>
                </div>
                <div class="filter-actions">
                  <button type="button" class="btn mat-flat-button btn-primary" (click)="onFilter()">
                    {{ changeTypeButton() ? 'Reset' : 'Filter' }}
                  </button>
                </div>
              </form>
            </mat-expansion-panel>
          </mat-accordion>